"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerDevicesEntity = void 0;
const BadRequestError_1 = require("../GS/BadRequestError");
const CustomerDeviceDto_1 = require("./CustomerDeviceDto");
const validators_1 = require("../GS/validators");
const SingleEntityBase_1 = require("../GS/SingleEntityBase");
const ValidationError_1 = require("../GS/ValidationError");
const INDEX_NOT_FOUND = -1;
class CustomerDevicesEntity extends SingleEntityBase_1.SingleEntityBase {
    constructor(dependencies, customerDevices) {
        super();
        this._requiredFieldsSetStatus = {
            appId: false,
            token: false,
            locationId: false,
            count: false,
            platform: false
        };
        this._dependencies = dependencies;
        if (customerDevices === undefined) {
            this._dto = new CustomerDeviceDto_1.CustomerDeviceDto();
        }
        else if (customerDevices instanceof CustomerDeviceDto_1.CustomerDeviceDto) {
            this._dto = new CustomerDeviceDto_1.CustomerDeviceDto(customerDevices);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else if (customerDevices instanceof CustomerDevicesEntity) {
            this._dto = new CustomerDeviceDto_1.CustomerDeviceDto(customerDevices._dto);
            this._clearAllRequiredFieldsSetStatuses();
            this._setIsNew(!this._dto.id);
        }
        else {
            throw new Error("Invalid arg");
        }
    }
    toDto() {
        return new CustomerDeviceDto_1.CustomerDeviceDto(this._dto);
    }
    getId() {
        return this._dto.id;
    }
    getAppId() {
        return this._dto.appId;
    }
    setAppId(untrustedValue) {
        let _untrustedValue;
        this.clearError("appId");
        this._requiredFieldsSetStatus.appId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("appId", "App Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("appId", "App is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.appId) {
            return;
        }
        this._dto.appId = _untrustedValue;
        this._setIsDirty(true);
    }
    getToken() {
        return this._dto.token;
    }
    setToken(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("token");
        this._requiredFieldsSetStatus.token = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("token", "Token is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("token", `Token has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.token) {
            return;
        }
        this._dto.token = _untrustedValue;
        this._setIsDirty(true);
    }
    getLocationId() {
        return this._dto.locationId;
    }
    setLocationId(untrustedValue) {
        let _untrustedValue;
        this.clearError("locationId");
        this._requiredFieldsSetStatus.locationId = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("locationId", "Location is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.locationId) {
            return;
        }
        this._dto.locationId = _untrustedValue;
        this._setIsDirty(true);
    }
    getCount() {
        return this._dto.count;
    }
    setCount(untrustedValue) {
        let _untrustedValue;
        this.clearError("count");
        this._requiredFieldsSetStatus.count = true;
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 0 })) {
            this.addError(new ValidationError_1.ValidationError("count", "Count is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (_untrustedValue === undefined || _untrustedValue === null) {
            this.addError(new ValidationError_1.ValidationError("count", "Count is required."));
        }
        if (!this.isNew && _untrustedValue === this._dto.count) {
            return;
        }
        this._dto.count = _untrustedValue;
        this._setIsDirty(true);
    }
    getPlatform() {
        return this._dto.platform;
    }
    setPlatform(untrustedValue) {
        const maxLength = 255;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("platform");
        this._requiredFieldsSetStatus.platform = true;
        if (_untrustedValue.length === 0) {
            this.addError(new ValidationError_1.ValidationError("platform", "Platform is required."));
        }
        else if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("platform", `Platform has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.platform) {
            return;
        }
        this._dto.platform = _untrustedValue;
        this._setIsDirty(true);
    }
    getCustomerId() {
        return this._dto.customerId;
    }
    setCustomerId(untrustedValue) {
        let _untrustedValue;
        this.clearError("customerId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("customerId", "Customer Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.customerId) {
            return;
        }
        this._dto.customerId = _untrustedValue;
        this._setIsDirty(true);
    }
    getLoginId() {
        return this._dto.loginId;
    }
    setLoginId(untrustedValue) {
        let _untrustedValue;
        this.clearError("loginId");
        if (untrustedValue !== undefined &&
            untrustedValue !== null &&
            !validators_1.isInt(untrustedValue, { min: 1 })) {
            this.addError(new ValidationError_1.ValidationError("loginId", "Customer Id is invalid."));
        }
        if (typeof untrustedValue === "string") {
            _untrustedValue = parseInt(untrustedValue, 10);
        }
        else {
            _untrustedValue = untrustedValue;
        }
        if (!this.isNew && _untrustedValue === this._dto.loginId) {
            return;
        }
        this._dto.loginId = _untrustedValue;
        this._setIsDirty(true);
    }
    getGcm() {
        return this._dto.gcm;
    }
    setGcm(untrustedValue) {
        let _untrustedValue;
        if (typeof untrustedValue === "number") {
            if (untrustedValue !== 0 && untrustedValue !== 1) {
                this.addError(new ValidationError_1.ValidationError("gcm", "Gcm is invalid."));
            }
            _untrustedValue = untrustedValue === 1;
        }
        else if (typeof untrustedValue === "string") {
            untrustedValue = untrustedValue.trim().toLowerCase();
            if (["0", "1", "false", "true"].indexOf(untrustedValue) === INDEX_NOT_FOUND) {
                this.addError(new ValidationError_1.ValidationError("gcm", "Gcm is invalid."));
            }
            _untrustedValue = [
                "1", "true"
            ].indexOf(untrustedValue) !== INDEX_NOT_FOUND;
        }
        else if (typeof untrustedValue === "boolean") {
            _untrustedValue = untrustedValue;
        }
        else {
            throw new Error("Invalid type");
        }
        if (!this.isNew && _untrustedValue === this._dto.gcm) {
            return;
        }
        this.clearError("gcm");
        this._dto.gcm = _untrustedValue;
        this._setIsDirty(true);
    }
    getTokenType() {
        return this._dto.tokenType;
    }
    setTokenType(untrustedValue) {
        const maxLength = 10;
        let _untrustedValue = untrustedValue !== null && untrustedValue !== void 0 ? untrustedValue : "";
        if (typeof _untrustedValue !== "string") {
            throw new Error("Invalid type");
        }
        _untrustedValue = _untrustedValue.trim();
        this.clearError("tokenType");
        if (_untrustedValue.length > maxLength) {
            this.addError(new ValidationError_1.ValidationError("tokenType", `TokenType has exceeded the maximum length (${maxLength} chr).`));
        }
        if (!this.isNew && _untrustedValue === this._dto.tokenType) {
            return;
        }
        this._dto.tokenType = _untrustedValue;
        this._setIsDirty(true);
    }
    getCreatedAt() {
        return this._dto.createdAt;
    }
    getUpdatedAt() {
        return this._dto.updatedAt;
    }
    getLastRegisteredAt() {
        return this._dto.lastRegisteredAt;
    }
    getLastDeviceCheck() {
        return this._dto.lastDeviceCheck;
    }
    loadAsync(id) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                if (typeof id === "string") {
                    if (!validators_1.isInt(id, { min: 1 })) {
                        throw new BadRequestError_1.BadRequestError("ID is not valid.");
                    }
                    id = parseInt(id, 10);
                }
                this._setState("busy");
                this._emit("before-loadAsync");
                this._dto = yield this._dependencies.customerDevicesDatastore
                    .getAsync(id);
                this._setIsNew(false);
                this._setIsDirty(false);
                this._clearAllRequiredFieldsSetStatuses();
                this.clearErrors();
                this._emit("after-loadAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    saveAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-saveAsync");
                if (!this.allRequiredFieldsSet) {
                    const fields = Object.entries(this._requiredFieldsSetStatus)
                        .filter(([, isSet]) => !isSet).map(([field]) => field);
                    throw new Error(`The following required fields were never set: ${fields.join(", ")}`);
                }
                if (!this.canSave) {
                    throw new Error("Customer Devices is not in a valid state.");
                }
                let dto = this.toDto();
                if (this.isNew) {
                    dto = yield this._dependencies.customerDevicesDatastore
                        .addAsync(this._dto);
                }
                else if (this.isDirty) {
                    dto = yield this._dependencies.customerDevicesDatastore
                        .updateAsync(this._dto);
                }
                this._dto.id = dto.id;
                this._dto.lastRegisteredAt = dto.lastRegisteredAt;
                this._dto.lastDeviceCheck = dto.lastDeviceCheck;
                this._dto.createdAt = dto.createdAt;
                this._dto.updatedAt = dto.updatedAt;
                this._setIsNew(false);
                this._setIsDirty(false);
                this._emit("after-saveAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
    deleteAsync() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                this._setState("busy");
                this._emit("before-deleteAsync");
                if (!this.canDelete) {
                    throw new Error("Customer Devices cannot be deleted.");
                }
                if (!this.isNew) {
                    yield this._dependencies.customerDevicesDatastore
                        .removeAsync(this.getId());
                }
                this._emit("after-deleteAsync");
            }
            catch (error) {
                this.addError(error);
                if (!this._hasEventListeners("error")) {
                    throw error;
                }
                this._emit("error", error);
            }
            finally {
                this._setState("ready");
            }
        });
    }
}
exports.CustomerDevicesEntity = CustomerDevicesEntity;
//# sourceMappingURL=CustomerDevicesEntity.js.map